/**
 * Helper function to get the taboola page details.
 * @param pageType - The type of the page.
 * @param url - The URL of the page.
 * @returns The taboola page details.
 */
export const getTaboolaPageDetails = (
  pageType: TaboolaPageType,
  url: string
): TaboolaPageDetails | null => {
  switch (pageType) {
    case "article":
      return { article: "auto", url };

    case "video":
      return { video: "auto", url };

    case "home":
      return { homepage: "auto", url };

    default:
      return null;
  }
};

/**
 * Helper function to get the taboola disclaimer text.
 * @param isShortText - The flag to check if the text should be short.
 * @returns {string} The taboola disclaimer text.
 */
export const getTaboolaDisclaimerText = (isShortText: boolean): string => {
  if (isShortText) {
    return "DeeperDive is a beta AI feature. Refer to full articles for the facts. ";
  }

  return "DeeperDive is a beta AI feature powered by Taboola. Refer to full articles for the facts and do not input any personal information.";
};
